<template>
  <div class="saas-template-detail">
    <div class="saas-template-detail__main">
      <ul class="breadcrumb-trail">
        <li>
          <nuxt-link :to="{ name: 'templates' }" class="breadcrumb-trail__link"
            >Templates</nuxt-link
          >
          <i class="iconoir-nav-arrow-right breadcrumb-trail__icon"></i>
        </li>
        <li>
          <span class="breadcrumb-trail__link breadcrumb-trail__link--active">{{
            template.name
          }}</span>
        </li>
      </ul>
      <div class="saas-template-detail__head">
        <div class="saas-template-detail__icon">
          <i :class="template.icon"></i>
        </div>
        <div class="saas-template-detail__title">
          {{ template.name }}
        </div>
        <div class="saas-template-detail__install">
          <Button @click="useTemplate()">Use this template</Button>
        </div>
      </div>
      <div class="saas-template-detail__preview">
        <TemplatePreview
          :template="template"
          class="saas-template-detail__preview-template"
        ></TemplatePreview>
      </div>
      <div class="saas-template-detail__body">
        <div class="saas-template-detail__properties">
          <div class="saas-template-detail__properties-sticky">
            <div class="saas-template-detail__properties-title">Categories</div>
            <div class="saas-template-detail__properties-value">
              <div
                v-for="category in template.categories"
                :key="category.id"
                class="saas-template-detail__properties-category"
              >
                {{ category.name }}
              </div>
            </div>
            <div class="saas-template-detail__properties-title">Level</div>
            <div class="saas-template-detail__properties-value">
              <TemplateLevel :level="template.level"></TemplateLevel>
            </div>
          </div>
        </div>
        <div class="saas-template-detail__content">
          <!-- eslint-disable vue/no-v-html -->
          <div class="margin-bottom-4" v-html="intro"></div>
          <!-- eslint-disable vue/no-v-html -->
          <div v-if="template.markdown_body !== ''" v-html="body"></div>
        </div>
      </div>
    </div>
    <UseTemplateModal ref="useModal" :template="template"></UseTemplateModal>
    <FooterJoin></FooterJoin>
  </div>
</template>

<script>
import TemplatePreview from '@baserow/modules/core/components/template/TemplatePreview'
import TemplateLevel from '@saas/components/template/TemplateLevel'
import FooterJoin from '@saas/components/footer/FooterJoin'

import TemplateService from '@saas/services/template'
import { MarkdownPage } from '@saas/markdown/markdownPage'
import UseTemplateModal from '@saas/components/template/UseTemplateModal'

export default {
  components: { TemplatePreview, UseTemplateModal, TemplateLevel, FooterJoin },
  layout: 'saas',
  middleware: 'settings',
  async asyncData({ error, app, params }) {
    const { slug } = params
    const data = {}

    try {
      const { data: template } = await TemplateService(app.$client).get(slug)
      data.template = template
    } catch {
      return error({ statusCode: 400, message: 'Could not load template.' })
    }

    // Render the markdown as html and extract the table of contents.
    const baseUrl = '/templates/' + slug
    const markdownIntro = new MarkdownPage(
      baseUrl,
      data.template.markdown_intro,
      app.$config
    )
    data.intro = markdownIntro.html
    const markdownBody = new MarkdownPage(
      baseUrl,
      data.template.markdown_body,
      app.$config
    )
    data.body = markdownBody.html

    return data
  },
  head() {
    return {
      title: this.template.title || this.template.name,
      meta: [
        {
          name: 'description',
          content: this.template.meta_description,
        },
      ],
    }
  },
  methods: {
    useTemplate() {
      this.$refs.useModal.show()
    },
  },
}
</script>
